export const ONE_PASSWORD_ELEMENT_NAME = 'com-1password-notification';

/**
 * Removes the 1Password prompt from the DOM.
 */
export function removeOnePasswordPrompt() {
  document.querySelector(ONE_PASSWORD_ELEMENT_NAME)?.remove();
}
